export default __webpack_public_path__ + "static/media/attached.icon.191d4ede.svg";